import { useEffect, useState } from 'react';
import './TypingDots.css';

const FRAMES = ['.', '..', '...'] as const;
const FRAME_MS = 400;

/** Animated . .. ... indicator shown on an editing user's avatar while they type. */
export function TypingDots() {
  const [frameIndex, setFrameIndex] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setFrameIndex((index) => (index + 1) % FRAMES.length);
    }, FRAME_MS);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <span className="typing-dots" aria-label="typing">
      <span className="typing-dots__text" aria-hidden="true">
        {FRAMES[frameIndex]}
      </span>
    </span>
  );
}
